// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 943 ? "partners" : chunkId) + "-legacy." + {"35":"c2475979","76":"87b4a3ff","120":"3d3c1ed2","129":"e0216e12","175":"3557e1a7","312":"18803884","642":"fa016d73","811":"ea1b24e8","830":"744736fa","856":"f4bc83ed","860":"c84d2d9c","894":"6742b11e","943":"10b2f422"}[chunkId] + ".js";
};